<template>
  <div class=''>
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div><img src="@/assets/images/tjtcLTD.png" alt="" /></div>
                  <p><br /></p>
                  <p class="text">
                    天津市旅游（控股）集团有限公司（以下简称“天津旅游集团”）坐落于河西区友谊路18号。2000年由市旅游局整建制转制为集团公司，2002年5月正式挂牌运营，是以文旅资源、产品开发运营与服务为主业的市属企业集团。天津旅游集团发挥文旅产业龙头企业作用，以文塑旅、以旅彰文，“串珠成链”带动天津文旅产业发展，助力特色鲜明的文化旅游目的地和国际消费中心城市建设。涵盖水上运营与管理、酒店运营与管理、旅行服务、文旅活动运营及项目开发、文旅商服务、乡村文旅、数字津旅、旅游汽车、物业管理、人力资源服务等10个主营业务板块，以及1个贸易业务板块，形成了“10+1”产业布局。20多年来，打造了“天津旅游名片”海河游船、“博物馆酒店”利顺德大饭店、“老字号旅行社”天津国旅等多个国内知名文旅品牌。</p>
                  <p><br /></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  beforeDestroy() { },
  methods: {}
}
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;

  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;

    .inner_content_right {

      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }

      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;
        ;

        .head {
          border-bottom: 1px #444 dashed;
          height: 500px;
        }
      }

      .text {
        text-indent: 45px;
      }

      .ltd {
        float: right;
      }
    }
  }
}
</style>
